import { JsonPipe } from '@angular/common';
import { Component, effect, inject, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseConfigurableComponent } from '@app/base-config.component';
import { LoadingComponent } from '@app/components/global/loading/loading.component';
import { BannerComponent } from '@app/components/shared/banner/banner.component';
import { QuestionComponent } from '@app/components/shared/form/question/question.component';
import { InputType } from '@app/enum/input-type';
import { QuestionBase } from '@app/models/question-base';
import { DropDownquestion } from '@app/models/questions/question-dropdown';
import { BranchService } from '@app/services/branch/branch.service';
import { Services } from '@app/services/fetch/service';
import { Settings } from '@app/services/fetch/settings';
import { QuestionControlService } from '@app/services/question/question-control.service';
import { SchedulerStepService } from '@app/services/step/scheduler-step.service';

@Component({
  selector: 'afcu-splash',
  standalone: true,
  providers: [QuestionControlService],
  imports: [QuestionComponent, BannerComponent, LoadingComponent],
  templateUrl: './splash.component.html'
})
export class SplashComponent extends BaseConfigurableComponent implements OnDestroy{
  protected fetchService = inject( Services );
  protected settings = inject( Settings );
  
  protected schedulerService = inject( SchedulerStepService );
  protected branchService = inject( BranchService );
  private readonly qcs = inject(QuestionControlService)
  protected target = ''


  enableWalkin = true
  enableCheckin = true
  enableBanner = true
  greeting = {
    title: '',
    description: ''
  }

  inputType : typeof InputType = InputType

  bannerContent:BannerType = {
    type: 'information',
    title: this.getText()['splash'].info.title,
    content:this.getText()['splash'].info.description
  }

  ngOnDestroy(): void {
    this.settings.stopAutoRefresh()
  }

  constructor (override route: ActivatedRoute, private router: Router) {
    super('page')
    this.target = this.route.snapshot.paramMap.get('reason')!
    this.route.data.subscribe(data => {
      this.target = data['target']
    });

    effect(() => {
      this.schedulerService.payload.set({})

      const selectedBranch = document.cookie
      const match = selectedBranch.match(/selectedBranch=([^;]+)/);

      let value = match ? match[1] : undefined

      if(value === undefined){
         this.route.queryParams.subscribe(params => {
          this.schedulerService.branchSelected.set(this.branchService.items().filter(branch => branch.branchID === params['branch'])[0])
        });
      } else {
        this.schedulerService.branchSelected.set(this.branchService.items().filter(branch => branch.branchID === value)[0])
      }
      
      let branchSettings = this.schedulerService.settings()[this.schedulerService.branchSelected().branchID]

      if( branchSettings === undefined){
        branchSettings = this.schedulerService.settings()['GLOBAL']
      }

      if(!branchSettings.kiosk_greeting_message){
        branchSettings.kiosk_greeting_message = this.schedulerService.settings()['GLOBAL'].kiosk_greeting_message
      }

      this.greeting = { 
        title: branchSettings.kiosk_greeting_message.text[this.textService.language().toLowerCase()].title,
        description: branchSettings.kiosk_greeting_message.text[this.textService.language().toLowerCase()].description,
      }

      if(branchSettings.kiosk_greeting_infobox){
        this.enableBanner = branchSettings.kiosk_greeting_infobox.enabled === true
        this.bannerContent = { 
          type: branchSettings.kiosk_greeting_infobox.severity[this.textService.language().toLowerCase()],
          title: branchSettings.kiosk_greeting_infobox.text[this.textService.language().toLowerCase()].title,
          content: branchSettings.kiosk_greeting_infobox.text[this.textService.language().toLowerCase()].description,
        }
      }

      if(branchSettings.kiosk_walkin){
        this.enableWalkin = branchSettings.kiosk_walkin.enabled
      } else {
        this.enableWalkin = this.schedulerService.settings()['GLOBAL'].kiosk_walkin.enabled
      }

      if(branchSettings.kiosk_checkin){
        this.enableCheckin = branchSettings.kiosk_checkin.kiosk_checkin_enabled
      }else{
        this.enableCheckin = this.schedulerService.settings()['GLOBAL'].kiosk_checkin.kiosk_checkin_enabled
      }
    })
  }
  questions: QuestionBase<string>[] = [this.FormLanguage]
  form: FormGroup = this.qcs.toFormGroup(this.questions as QuestionBase<string>[]);

  get FormLanguage() {
    return new DropDownquestion ({
      key: 'language',
      options: this.textService.DropDownLanguage,
      externalFunction: "changeLanguage",
      order: 1
    })
  }

  renderTemplate(template: string): string {
    return template.replace(/{{\s*branch\.(\w+)\s*}}/g, (_, prop) => {
      const key = prop as keyof Branch;
      const value = this.schedulerService.branchSelected()[key];
      return String(value ?? '');
    });
  }

  selectEvent(event: { function: string; value: string | CategorySelected | Branch }): void {
    if (event.function === 'changeLanguage'){
      this.textService.setLanguage(event.value.toString())
    }
  }

  gotTo(walkIn: boolean) {
    this.schedulerService.reset()
    
    if (walkIn)
      this.router.navigate(['/services/', this.schedulerService.branchSelected().branchID], { queryParams: { origin: 'queue' }, queryParamsHandling: 'merge'})
    else
      this.router.navigate(['/check-in'], { queryParams: { origin: 'queue' }, queryParamsHandling: 'merge'})
  }
}
